import { z } from 'zod';

export const teamsSchema = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string(),
});
